import { ReactNode } from 'react';

import { SearchBarProps } from 'components/SearchBar/SearchBar';
import { Stack } from 'libs/ui';

import { SearchBarStyled } from './styles';

interface Props extends Omit<SearchBarProps, 'leftElement'> {
  filterContent: ReactNode;
}

export const SearchBarWithFilter = ({
  filterContent,
  ...searchProps
}: Props) => (
  <Stack alignItems="center" direction="row" flexWrap="wrap" spacing={12}>
    <SearchBarStyled {...searchProps} />
    {filterContent}
  </Stack>
);
